import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["SearchOfficesFilterForm"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/app/[locale]/offices/components/forms/SearchOfficesFilterForm.tsx");
;
import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/assets/images/logo-vivaldis.svg");
;
import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/assets/images/social_share.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/atoms/CardLinkNavigationIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/blocks/TranslatedPaths.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/forms/NewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/molecules/IsOpenMessage.tsx");
